jQuery(function () {

	jQuery(window).scroll(function () {
		if (jQuery(this).scrollTop()) {
			jQuery('#back-top').fadeIn();
		} else {
			jQuery('#back-top').fadeOut();
		}
	});

	jQuery("#back-top").click(function () {
		//1 second of animation time
		//html works for FFX but not Chrome
		//body works for Chrome but not FFX
		//This strange selector seems to work universally
		jQuery("html, body").animate({ scrollTop: 0 }, 1500);

	});
	jQuery('#back-bottom').on('click', function() {
		var headerHeight = jQuery('#myHeader').outerHeight();
		var target = jQuery(this).attr('href');
		var offsetTop = jQuery(target).offset().top;
		offsetTop = offsetTop - headerHeight;
		jQuery('html, body').animate({ scrollTop: offsetTop}, 1500);
	});
	

  jQuery(document).ready(function () {
    jQuery("button.navbar-toggle").on("click", function () {
      jQuery("body").toggleClass("open-menu");
    });
  });
});




jQuery(window).scroll(function () {
  var sticky = jQuery("#myHeader"),
    scroll = jQuery(window).scrollTop();
  if (scroll >= 5) {
    sticky.addClass("sticky");
  } else {
    sticky.removeClass("sticky");
  }
});



jQuery(document).ready(function () {
  if (jQuery(window).width() > 1199) {
    jQuery("li.mega-menu ul.sub-menu").wrap(
      "<div class='hover_mega_menu'></div>"
    );
    jQuery("li.mega-menu2 ul.sub-menu").wrap(
      "<div class='hover_mega_menu'></div>"
    );

  }
});

jQuery(".logo-slider").owlCarousel({
  center: false,
  items:5,
  loop:true,
  margin:40,
  nav:false,
  dots:false,
  autoplay: true,
  slideTransition: 'linear',
  autoplayTimeout: 2000,
  autoplaySpeed: 2000,
  autoplayHoverPause: true,
  responsive: {
    0: {
    items: 2,
    autoHeight: true,
    margin: 10,
    },
    420: {
    items: 3,
    margin: 10,
    },
    600: {
    items: 4,
    margin: 10,
    },
    700: {
    items: 4,
    margin: 15,
    },
    813: {
    items: 5,
    margin: 15,
    },
    1200: {
    items:6,
    margin: 10,
    },
    1500: {
    items:5,
    margin: 40,
    },
  },
});


jQuery(".best-seller-slider").owlCarousel({
    loop: true,
    margin: 30,
    items: 5,
    nav: true,
    dots: false,
    autoHeight: true,
    responsive: {
      0: {
        items: 2,
        center: false,
        autoHeight: true,
        margin: 10,
      },
      600: {
        center: false,
        items: 3,
        margin: 10,
      },
      767: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 10,
      },
      900: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 20,
      },
      1300: {
        nav: true,
        dots: false,
        center: false,
        items: 5,
        margin: 30,
      },
    },
  });


  
jQuery(".gallery-slider").owlCarousel({
    loop: true,
    margin: 30,
    items: 3,
    nav: true,
    dots: false,
    autoHeight: true,
    responsive: {
      0: {
        items: 2,
        center: false,
        autoHeight: true,
        margin: 10,
      },
      575: {
        center: false,
        items: 3,
        margin: 10,
      },
      767: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 20,
      },
      900: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 20,
      },
      1300: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 30,
      },
    },
  });


jQuery(function () {
    var owl = jQuery(".testimonial-slider");

    owl.owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        margin: 20,
        responsive: {
            0: {
                items: 1,
                center: true,
                stagePadding: 60,
                autoHeight: true,
        margin: 0,
            },
            576: {
                items: 2,
                center: false,
                stagePadding: 0,
        margin: 10,
            },
            768: {
                items: 3,
        margin: 10,
            },
            1200: {
                items: 4,
        margin: 10,
            },
            1500: {
                items: 5
            }
        }
    });
});

  
jQuery(".related-product-slider").owlCarousel({
    loop: true,
    margin: 30,
    items: 5,
    nav: true,
    dots: false,
    autoHeight: true,
    responsive: {
      0: {
        items: 2,
        center: false,
        autoHeight: true,
        margin: 10,
      },
      600: {
        center: false,
        items: 3,
        margin: 10,
      },
      767: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 10,
      },
      900: {
        nav: true,
        dots: false,
        center: false,
        items: 3,
        margin: 20,
      },
      1300: {
        nav: true,
        dots: false,
        center: false,
        items: 5,
        margin: 30,
      },
    },
  });

jQuery(window).on('scroll', function () {

  var sticky = jQuery(".site-main .single_add_to_cart_button");
  var scroll = jQuery(window).scrollTop();

  // 0px se 299px → sticky ON
  if (scroll < 300) {
    sticky.addClass("sticky");
  }
  // 300px se 299px → sticky OFF
  else if (scroll >= 301 && scroll < 1200) {
    sticky.removeClass("sticky");
  }
  // 300px ke baad → sticky ON again
  else if (scroll >= 1201) {
    sticky.addClass("sticky");
  }

});

